import { CuratedBrandStoreRestrictionLevel } from 'swag-common/interfaces';
import { ALLOWED_PATH_CBS_RESTRICTED_LEVEL, ALLOWED_PATH_CBS_RESTRICTED_LEVEL_REG } from 'swag-common/constants/curated-brand-store.constants';
export const checkIsRestrictedCuratedBrandStore = restrictionLevel => {
  return restrictionLevel === CuratedBrandStoreRestrictionLevel.RESTRICTED;
};
export function isAllowedPathForCBSRestrictedLevel(path) {
  return ALLOWED_PATH_CBS_RESTRICTED_LEVEL.includes(path) || RegExp(ALLOWED_PATH_CBS_RESTRICTED_LEVEL_REG).test(path);
}